import { useState, useRef, useEffect, useMemo } from "react";

import api from "@helpers/api";

import { useCommunity } from "@contexts/CommunityContext";

import * as Mui from "@mui/material";

import CustomModal from "@components/CustomModal";

import {Text} from "@fragments";

import "./styles.css";

import { KeyboardArrowRightRounded, SellRounded } from "@mui/icons-material";
import Parser from "@helpers/parser";
import RefundRequestModal from "../RefundRequestModal";

export default function UserModal({ modalRef }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [user, setUser] = useState({});

  const { community } = useCommunity();

  const REF_userId = useRef({});
  const REF_callback = useRef();

  const REF_refundModal = useRef();

  if (!modalRef) return null;

  modalRef.current = {
    open(userId, callback = () => {}) {
      if (!userId) return;
      REF_userId.current = userId;
      REF_callback.current = callback;
      loadUser();
      setOpen(true);
    },
  };

  async function loadUser() {
    setLoading(true);

    try {
      const searchStr = "community/member?full=true&id=" + REF_userId.current;

      const { data } = await api.get(searchStr);

      setUser({ ...data });
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  }

  function handleMemberClick(user) {}
  function handleRequestRefund(charge) {
    console.log(charge);
    REF_refundModal.current.open(charge, loadUser);
  }
  function handleRequestCancel(membership) {
    window.openConfirm({
      title: "Cancelar assinatura",
      headline: "Atenção!",
      subtitle: "Você realmente deseja cancelar a assinatura deste usuário?",
      buttons: [
        {
          text: "Cancelar assinatura",
          onClick: handleExecuteCancel,
          variant: "contained",
          className: "",
          color: "error",
        },
        {
          text: "Manter assinatura",
          variant: "text",
        },
      ],
    });

    async function handleExecuteCancel() {
      console.log("MEM", membership);

      try {
        const { data } = await api.post("subscription/cancel", {
          id: membership.subscription.provider.id,
        });

        loadUser();
      } catch (e) {
        window.setSnackbar(
          "Houve um erro ao apagar este post, tente novamente mais tarde"
        );
      }
    }
  }

  function Payments() {
    if (!user?.id) return null;

    function MembershipBlock({ data }) {
      function Charge({ charge }) {
        return (
          <div className="charge-row">
            <div className="title-charge">
              <span>
                <span className="bold">Valor bruto:</span> R$
                {Parser.price.brl(charge.amount)}
              </span>
            </div>

            {charge.deleted ? (
              <div className="refunded">
                <span>Estornada</span>
              </div>
            ) : (
              <div
                className="anchor"
                onClick={() => handleRequestRefund(charge)}
              >
                Estornar
              </div>
            )}
          </div>
        );
      }
      return (
        <div className="payment-received-row mb-3">
          <div className="community-payments-title mb-1">
            <img src={data.community.banner} className="cp-banner" />
            <h4 className="bold membership-community">{data.community.name}</h4>
            {data.subscription?.status === 'canceled' && (
              <div className="refunded">
                <span>Cancelada</span>
              </div>
            )}
            {["active", "pending"].includes(data.subscription?.status) &&
              !data.subscription?.canceled && (
                <div
                  className="anchor"
                  onClick={() => handleRequestCancel(data)}
                >
                  Cancelar assinatura
                </div>
              )}
          </div>

          {data.payments.map((charge, k) => (
            <Charge charge={charge} key={k} />
          ))}
        </div>
      );
    }

    return (
      <div className="mb-2">
        {user?.memberships.map((membership, mi) => (
          <MembershipBlock data={membership} key={mi} />
        ))}
      </div>
    );
  }

  return (
    <>
      <CustomModal
        maxWidth={450}
        bottomButtonCancelText="Concluir"
        loading={loading}
        title="Detalhes do usuário"
        open={open}
        handleClose={() => setOpen(false)}
        bodyComponent={
          open ? (
            <div className="px-4 py-2 user-details">
              {!loading && (
                <>
                  <img className="avatar mt-2" src={user?.avatar} />
                  <h4 className="center bold mt-1">{user?.username}</h4>
                  <h5 className="center">{user?.email?.address}</h5>

                  <Text.h3 icon={<SellRounded />} value="Histórico de pagamentos" />

                  <Payments />
                </>
              )}
            </div>
          ) : null
        }
      />

      <RefundRequestModal modalRef={REF_refundModal} />
    </>
  );
}
